export const TextColors = {
  gray: "#6b7280",
  red: "#b91c1c",
  orange: "#f97316",
  yellow: "#eab308",
  green: "#15803d",
  blue: "#1d4ed8",
  purple: "#7e22ce",
} as const;

export const HighlightColors = {
  gray: "#e5e7eb",
  red: "#fecaca",
  orange: "#fed7aa",
  yellow: "#fef08a",
  green: "#bbf7d0",
  blue: "#bfdbfe",
  purple: "#e9d5ff",
} as const;

export const CardColors = {
  // ...HighlightColors,
  yellow: "#fef08a",
  orange: "#fed7aa",
  red: "#fecaca",
  green: "#bbf7d0",
  white: "#ffffff",
  gray: "#e5e7eb",
  blue: "#bfdbfe",
  purple: "#e9d5ff",
} as const;

export const SectionPreviewColors = {
  "#ffffff": "#ffffff", // white
  "#fefce8": "#fef08a", // yellow
  "#fff7ed": "#fed7aa", // orange
  "#fef2f2": "#fecaca", // red
  "#f9fafb": "#dedede", // grey
  "#f0fdf4": "#bbf7d0", // green
  "#eff6ff": "#bfdbfe", // blue
  "#faf5ff": "#e9d5ff", // purple
} as const;

export const PencilShapeColors = {
  gray: "#030712",
  red: "#ef4444",
  orange: "#fb923c",
  yellow: "#facc15",
  green: "#65a30d",
  blue: "#3b82f6",
  purple: "#9333ea",
  white: "#ffffff",
} as const;

export const CalloutFlyoutColors = {
  default: "#ffffff",
  yellow: "#fef08a",
  orange: "#fed7aa",
  red: "#fecaca",
  grey: "#e5e7eb",
  green: "#bbf7d0",
  blue: "#bfdbfe",
  purple: "#e9d5ff",
} as const;
